"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Asset_1 = require("./Asset");
var AnimationLayersArray_1 = require("../layers/AnimationLayersArray");
var CompositionAsset = (function (_super) {
    tslib_1.__extends(CompositionAsset, _super);
    function CompositionAsset(rawData, version) {
        var _this = _super.call(this, Asset_1.AssetType.Precomp, rawData, version) || this;
        _this.findLayersByName = function (name) {
            return _this.layersArray.findLayersByName(name);
        };
        _this.findFirstLayerByName = function (name) {
            return _this.layersArray.findFirstLayerByName(name);
        };
        _this.getLayers = function () {
            return _this.layersArray.getLayers();
        };
        _this.findLayerByIndex = function (index) {
            return _this.layersArray.findLayerByIndex(index);
        };
        if (_this._rawData.layers) {
            _this.layersArray = new AnimationLayersArray_1.AnimationLayersArray(_this._rawData.layers, version);
        }
        return _this;
    }
    return CompositionAsset;
}(Asset_1.Asset));
exports.CompositionAsset = CompositionAsset;
//# sourceMappingURL=CompositionAsset.js.map